var CHAT_MODAL_SHOW = 'CHAT_MODAL_SHOW';
var CHAT_MODAL_HIDE = 'CHAT_MODAL_HIDE';
var REDUCER_CHAT_MODAL_NAME = 'reducerChatModal';
export { CHAT_MODAL_SHOW, CHAT_MODAL_HIDE, REDUCER_CHAT_MODAL_NAME };